<template>
  <div class="merchNum fadeInRight">
    <div class="title-box clearfix">
      <span class="m-title">商户号</span>
      <el-form
        :inline="true"
        :model="formInline"
        class="right themed-form search-form"
        style="height: auto; line-height: 40px"
      >
        <el-form-item label="关键字：">
          <el-input
            v-model="formInline.pageSearchKeys"
            placeholder="输入商户号名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="searchData"
            icon="el-icon-search"
            class="themed-button"
            >搜索查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addAgentRecord"
            icon="el-icon-plus"
            class="themed-button"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="content-box">
      <el-table
        :data="tabledata"
        stripe
        style="width: 100%"
        ref="table"
        :max-height="maxTableHeight"
        border
      >
      <el-table-column
                    show-overflow-tooltip
                    label="商户类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1||scope.row.type==''">微信</span>
                        <span v-else-if="scope.row.type==2">乐刷</span>
                         <span v-else-if="scope.row.type==3">银联</span>
                         <span v-else-if="scope.row.type==4">通联</span>
                         <span v-else-if="scope.row.type==5">支付宝</span>
                    </template>
            </el-table-column>
        <el-table-column prop="name" label="商户号名称"> </el-table-column>
        <el-table-column prop="mchId" label="商户号ID"> </el-table-column>
        <!-- 新UI时显示状态和排序列 -->
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="状态" width="80" v-if="SHOW_MERCHNUM == 1">
          <template slot-scope="scope">
            <el-tag 
              :type="scope.row.statusBoolean ? 'success' : 'info'" 
              size="small">
              {{ scope.row.statusBoolean ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortValue" label="排序值" width="80" v-if="SHOW_MERCHNUM == 1">
          <template slot-scope="scope">
            <span>{{ scope.row.sortValue || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- 新UI模式下只显示编辑和删除 -->
            <template v-if="SHOW_MERCHNUM == 1">
              <span @click="edit(scope.row.id)" class="operation-btn">编辑</span>
              <span @click="deleteById(scope.row.id)" class="operation-btn left_agent">删除</span>
            </template>
            <!-- 原有UI模式下显示所有操作 -->
            <template v-else>
              <span v-if="scope.row.isDefault">当前默认</span>
              <span v-else @click="updateRecord(scope.row.id)">设为默认</span>
              <span @click="edit(scope.row.id)" class="left_agent">编辑</span>
              <span @click="deleteById(scope.row.id)" class="left_agent">删除</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 15, 25, 100]"
        :page-size="pageSize"
        style="text-align: left; margin-top: 20px"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="onPageChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="新增商户号"
      :visible.sync="dialogAddMerchVisible"
      :before-close="handleCloseAddMerch"
      v-if="dialogAddMerchVisible"
    >
      <el-form :model="formAddMerch" ref="ruleFormAddMerch">
         <el-form-item
          label="商户类型:"
          :label-width="formLabelWidth"
          required
        >
          <el-select v-model="formAddMerch.type" required @change="typeChange">
            <el-option label="微信" value="1"></el-option>
            <el-option label="乐刷" value="2"></el-option>
            <el-option label="银联" value="3"></el-option>
            <el-option label="通联" value="4"></el-option>
            <el-option label="支付宝" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称：" :label-width="formLabelWidth" required>
          <el-input v-model="formAddMerch.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="ID：" :label-width="formLabelWidth" required>
          <el-input
            v-model="formAddMerch.mchId"
            autocomplete="off"
            :maxlength="formAddMerch.type == '5' ? 16 : undefined"
            :show-word-limit="formAddMerch.type == '5'"
          ></el-input>
        </el-form-item>
        <el-form-item label="交易秘钥：" :label-width="formLabelWidth" required v-show="formAddMerch.type!='4'">
          <el-input v-model="formAddMerch.key" autocomplete="off"></el-input>
        </el-form-item>
       <el-form-item label="异步回调密钥:" :label-width="formLabelWidth" required v-show="formAddMerch.type=='2'" >
					<el-input v-model="formAddMerch.keyAsync" autocomplete="off"></el-input>
				</el-form-item>
        <el-form-item label="证书：" :label-width="formLabelWidth" required  v-show="formAddMerch.type=='1'">
          <input
            class="file-input"
            type="file"
            ref="fileInput"
            @change="fileChange"
          />
        </el-form-item>
        <el-form-item label="APPID:" :label-width="formLabelWidth" required v-show="formAddMerch.type=='4' || formAddMerch.type=='5'">
          <el-input v-model="formAddMerch.appid" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公钥:" :label-width="formLabelWidth" required v-show="formAddMerch.type=='5'">
          <el-input v-model="formAddMerch.keyAsync" autocomplete="off"></el-input>
        </el-form-item>
        <!-- 新UI时显示状态和排序字段 -->
        <el-form-item label="启用状态:" :label-width="formLabelWidth" v-if="SHOW_MERCHNUM == 1">
          <el-switch
            v-model="formAddMerch.statusBoolean"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="启用"
            inactive-text="停用">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序值:" :label-width="formLabelWidth" v-if="SHOW_MERCHNUM == 1">
          <el-input-number 
            v-model="formAddMerch.sortValue" 
            :min="0"
            placeholder="输入排序值">
          </el-input-number>
          <span style="margin-left: 10px; color: #999; font-size: 12px;">按从小到大排序显示</span>
        </el-form-item>
        <el-form-item label="RSA私钥:" :label-width="formLabelWidth" required v-show="formAddMerch.type=='4'">
          <el-input v-model="formAddMerch.keyAsync" autocomplete="off"></el-input>
        </el-form-item>
         <el-form-item label="SM2私钥:" :label-width="formLabelWidth" required v-show="formAddMerch.type=='4'">
          <el-input v-model="formAddMerch.key" autocomplete="off"></el-input>
        </el-form-item>
          <el-form-item label="银联商户号类型:" :label-width="formLabelWidth" v-if="formAddMerch.type=='3'">
                <el-radio-group v-model="formAddMerch.unionType" >
                    <el-radio label="1">关注商户号</el-radio>
                    <el-radio label="2">特邀商户号</el-radio>
                </el-radio-group>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="formAddMerchSubmit('ruleFormAddMerch')"
          class="themed-button"
          >确 定</el-button
        >
        <el-button
          type="info"
          @click="formAddMerchReset('ruleFormAddMerch')"
          class="themed-button"
          >重置</el-button
        >
        <el-button
          type="info"
          @click="cancelDialogformAddMerch('ruleFormAddMerch')"
          class="themed-button"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑商户号"
      :visible.sync="dialogEditMerchVisible"
      v-if="dialogEditMerchVisible"
    >
      <el-form :model="formEditMerch">
        <el-form-item label="密钥V3(非必填):" :label-width="formLabelWidth">
          <el-input
            v-model="formEditMerch.keyVerThree"
            autocomplete="off"
          ></el-input>
		  <p>若使用[商家转账到零钱]请配置此项</p>
        </el-form-item>
        <!-- 新UI时显示状态和排序字段 -->
        <el-form-item label="启用状态:" :label-width="formLabelWidth" v-if="SHOW_MERCHNUM == 1">
          <el-switch
            v-model="formEditMerch.statusBoolean"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="启用"
            inactive-text="停用">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序值:" :label-width="formLabelWidth" v-if="SHOW_MERCHNUM == 1">
          <el-input-number 
            v-model="formEditMerch.sortValue" 
            :min="0"
            placeholder="输入排序值">
          </el-input-number>
          <span style="margin-left: 10px; color: #999; font-size: 12px;">按从小到大排序显示</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="formEditMerchSubmit"
          class="themed-button"
          >确 定</el-button
        >
        <el-button type="info" @click="formEditMerchReset" class="themed-button"
          >重置</el-button
        >
        <el-button
          type="info"
          @click="formEditMerchCancel"
          class="themed-button"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import onresize from "@/mixins/resize.js";
import loading from "@/utils/Loading.js";
import {
  merchantList,
  deleteMerchant,
  addMerchantNum,
  uploadFile,
  setDefault,
  editMerchant,
  editSaveMerchant,
} from "@/api/payManagment.js";
export default {
  name: "merchNum",
  mixins: [onresize],
  data() {
    return {
      page: 1,
      pageSize: 15,
      total: 0,
      formInline: {
        pageSearchKeys: "",
      },
      tabledata: [],
      dialogAddMerchVisible: false,
      formAddMerch: {
        type:"1",
        certPath: "",
        name: "",
        mchId: "",
        key: "",
        keyAsync:"",
        unionType:"1",
        appid:"",
        // 新UI字段 - 仅在SHOW_MERCHNUM==1时使用
        statusBoolean: true, // 启用状态，默认启用
        sortValue: 0, // 排序值，默认为0
      },
      formLabelWidth: "150px",
      dialogEditMerchVisible: false,
      formEditMerch: {
        id: "",
        keyVerThree: "",
        // 新UI字段 - 仅在SHOW_MERCHNUM==1时使用
        statusBoolean: true, // 启用状态
        sortValue: 0, // 排序值
      },
      resetkeyVerThree: "",
      // 缓存原始值用于重置
      resetStatus: true,
      resetSortValue: 0,

    };
  },
  created() {
    this.getMerchantList(this.formInline);
  },
  computed: {
    // 获取SHOW_MERCHNUM状态
    SHOW_MERCHNUM() {
      return this.$store.getters.SHOW_MERCHNUM;
    }
  },
  methods: {
    typeChange(val){
      this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.unionType  = "1"
      this.formAddMerch.appid = ""
      this.formAddMerch.statusBoolean = true
      this.formAddMerch.sortValue = 0
    },
    getMerchantList(params) {
      merchantList(params).then((res) => {
        // 处理返回数据，转换status为boolean用于前端显示
        if (res.rows && res.rows.length > 0) {
          res.rows.forEach(item => {
            // 将status值转换为boolean类型供switch组件使用
            item.statusBoolean = item.status == null ? true : item.status == 1;
            // 确保排序值不为空
            if (item.sortValue == null || item.sortValue == undefined) {
              item.sortValue = 0;
            }

          });
        }
        this.tabledata = res.rows;
        this.page = res.pageNo;
        this.pageSize = res.pageSize;
        this.total = res.total;
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      let params = {
        pageSize: this.pageSize,
        pageNo: this.page,
        pageSearchKeys: this.formInline.pageSearchKeys,
      };
      this.getMerchantList(params);
    },
    onPageChange(page) {
      this.page = page;
      let params = {
        pageSize: this.pageSize,
        pageNo: this.page,
        pageSearchKeys: this.formInline.pageSearchKeys,
      };
      this.getMerchantList(params);
    },
    searchData() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.page,
        pageSearchKeys: this.formInline.pageSearchKeys,
      };
      this.getMerchantList(params);
    },
    updateRecord(id) {
      this.$confirm(
        "未关联商户号的代理商将使用该商户号，若需关联商户号，请至[代理商-商户号]页面，确定设为默认？",
        "消息提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            id: id,
          };
          setDefault(params).then(() => {
            this.$message({
              type: "success",
              message: "设置成功!",
            });
            this.searchData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消设置",
          });
        });
    },
    deleteById(id) {
      this.$confirm("确定要删除该商户号吗？", "消息提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: id,
          };
          deleteMerchant(params).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getMerchantList(this.formInline);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    edit(id) {
      this.dialogEditMerchVisible = true;
      this.formEditMerch.id = id;
      editMerchant({ id }).then((res) => {
        this.formEditMerch.keyVerThree = res.keyVerThree;
        this.resetkeyVerThree = res.keyVerThree;
        // 处理新UI字段
        if (this.SHOW_MERCHNUM == 1) {
          this.formEditMerch.statusBoolean = res.status == null ? true : res.status == 1;
          this.formEditMerch.sortValue = res.sortValue || 0;
          // 缓存原始值用于重置
          this.resetStatus = this.formEditMerch.statusBoolean;
          this.resetSortValue = this.formEditMerch.sortValue;
        }
      });
    },
	formEditMerchCancel(){
    this.formEditMerch.id = ""
    this.formEditMerch.keyVerThree =""
    this.formEditMerch.statusBoolean = true
    this.formEditMerch.sortValue = 0
	this.dialogEditMerchVisible = false
	},
    formEditMerchSubmit() {
      // 新UI模式下检查排序值唯一性（排除当前编辑的记录）
      if (this.SHOW_MERCHNUM == 1 && this.formEditMerch.sortValue !== null && this.formEditMerch.sortValue !== undefined) {
        const existingMerchant = this.tabledata.find(item => 
          item.sortValue === this.formEditMerch.sortValue && item.id !== this.formEditMerch.id
        );
        if (existingMerchant) {
          this.$alert(`排序值 ${this.formEditMerch.sortValue} 已被商户"${existingMerchant.name}"使用，请使用不同的排序值！`, "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      
      // 处理新UI字段的数据转换
      let submitData = { ...this.formEditMerch };
      if (this.SHOW_MERCHNUM == 1) {
        // 将boolean转换为整型传给后端
        submitData.status = this.formEditMerch.statusBoolean ? 1 : 0;
      }
      editSaveMerchant(submitData).then((res) => {
        if (res.system_result_key == 0) {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success",
          });
          let params = {
            pageSize: this.pageSize,
            pageNo: 1,
            pageSearchKeys: this.formInline.pageSearchKeys,
          };
          this.getMerchantList(params);
          this.dialogEditMerchVisible = false;
        } else if (res.slide_msg_key == 1) {
          this.$message({
            showClose: true,
            message: res.slide_msg_message_key,
          });
          this.dialogEditMerchVisible = false;
        }
      });
    },
    formEditMerchReset() {
      this.formEditMerch.keyVerThree = this.resetkeyVerThree;
      // 重置新UI字段
      if (this.SHOW_MERCHNUM == 1) {
        this.formEditMerch.statusBoolean = this.resetStatus;
        this.formEditMerch.sortValue = this.resetSortValue;
      }
    },
    addAgentRecord() {
      this.dialogAddMerchVisible = true;
        this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.unionType = "1"
      this.formAddMerch.appid = ""
      this.$nextTick(()=>{
         this.$refs["fileInput"].value = "";
       })
     
    },
    formAddMerchSubmit() {
      if (
        this.formAddMerch.name == null ||
        this.formAddMerch.name == "" ||
        this.formAddMerch.name == 0
      ) {
        this.$alert("请填写名称", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.formAddMerch.mchId == null ||
        this.formAddMerch.mchId == "" ||
        this.formAddMerch.mchId == 0
      ) {
        this.$alert("请填写商户ID！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.formAddMerch.type == "5" &&
        String(this.formAddMerch.mchId).trim().length !== 16
      ) {
        this.$alert("ID必须为16位", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.formAddMerch.key == null ||
        this.formAddMerch.key == "" ||
        this.formAddMerch.key == 0 
      ) {
        if(this.formAddMerch.type == "4"){  
          this.$alert("请填写SM2私钥！", "提示", {
            confirmButtonText: "确定",
          });
        }else{
          this.$alert("请填写交易秘钥！", "提示", {
            confirmButtonText: "确定",
          });
        }
        return;
      }
       if ((
        this.formAddMerch.keyAsync == null ||
        this.formAddMerch.keyAsync == "" ||
        this.formAddMerch.keyAsync == 0)  && this.formAddMerch.type == "2"
      ) {
       
        this.$alert("请填写异步回调密钥！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if ((
        this.$refs["fileInput"].files[0] == undefined ||
        this.$refs["fileInput"].files[0] == "" ||
        this.$refs["fileInput"].files[0] == null) && this.formAddMerch.type == "1"
      ) {
        this.$alert("请上传证书！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if ((
        this.formAddMerch.appid == null ||
        this.formAddMerch.appid == "" ||
        this.formAddMerch.appid == 0) && (this.formAddMerch.type == "4" || this.formAddMerch.type == "5")
      ) {
        this.$alert("请填写APPID！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if ((
        this.formAddMerch.keyAsync == null ||
        this.formAddMerch.keyAsync == "" ||
        this.formAddMerch.keyAsync == 0) && this.formAddMerch.type == "4"
      ) {
        this.$alert("请填写RSA私钥！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if ((
        this.formAddMerch.keyAsync == null ||
        this.formAddMerch.keyAsync == "" ||
        this.formAddMerch.keyAsync == 0) && this.formAddMerch.type == "5"
      ) {
        this.$alert("请填写公钥！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      
      // 新UI模式下检查排序值唯一性
      if (this.SHOW_MERCHNUM == 1 && this.formAddMerch.sortValue !== null && this.formAddMerch.sortValue !== undefined) {
        const existingMerchant = this.tabledata.find(item => 
          item.sortValue === this.formAddMerch.sortValue
        );
        if (existingMerchant) {
          this.$alert(`排序值 ${this.formAddMerch.sortValue} 已被商户"${existingMerchant.name}"使用，请使用不同的排序值！`, "提示", {
            confirmButtonText: "确定",
          });
          this.dialogAddMerchVisible = true;
          return;
        }
      }
      
      this.dialogAddMerchVisible = false;

      loading.show();
      // 处理新UI字段的数据转换
      let submitData = { ...this.formAddMerch };
      if (this.SHOW_MERCHNUM == 1) {
        // 将boolean转换为整型传给后端
        submitData.status = this.formAddMerch.statusBoolean ? 1 : 0;
      }
      addMerchantNum(submitData).then((res) => {
        this.$message({
          type: "success",
          message: "新增成功",
        });
        this.getMerchantList(this.formInline);
        this.dialogAddMerchVisible = false;
      this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.type = "1"
      this.formAddMerch.unionType = "1"
      this.formAddMerch.appid = ""
      this.formAddMerch.statusBoolean = true
      this.formAddMerch.sortValue = 0
        this.$refs["fileInput"].value = "";
      });
    },
    formAddMerchReset() {
      this.dialogAddMerchVisible = false;
      this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.type = "1"
      this.formAddMerch.unionType = "1"
      this.formAddMerch.appid = ""
      this.formAddMerch.statusBoolean = true
      this.formAddMerch.sortValue = 0
      this.$refs["fileInput"].value = "";
    },
    cancelDialogformAddMerch() {
      this.dialogAddMerchVisible = false;
      this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.type = "1"
      this.formAddMerch.unionType = "1"
      this.formAddMerch.appid = ""
      this.formAddMerch.statusBoolean = true
      this.formAddMerch.sortValue = 0
      this.$refs["fileInput"].value = "";
    },
    fileChange() {
      let formData = new FormData();
      formData.append("file", this.$refs["fileInput"].files[0]);
      uploadFile(formData).then((res) => {
        console.log(res.filePath);
        this.formAddMerch.certPath = res.filePath;
      });
    },
    handleCloseAddMerch(done) {
      this.dialogAddMerchVisible = false;
      this.formAddMerch.certPath = ""
      this.formAddMerch.name = ""
      this.formAddMerch.mchId  = ""
      this.formAddMerch.key = ""
      this.formAddMerch.keyAsync = ""
      this.formAddMerch.type = "1"
      this.formAddMerch.unionType = "1"
      this.formAddMerch.appid = ""
      this.formAddMerch.statusBoolean = true
      this.formAddMerch.sortValue = 0
      this.$refs["fileInput"].value = "";
      done();
    },

  },
};
</script>

<style>
.merchNum .el-form-item__label {
  vertical-align: top;
}

.left_agent {
  margin-left: 8px;
}

/* 新UI模式下的操作按钮样式 */
.operation-btn {
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 3px;
  transition: all 0.2s;
}

.operation-btn:hover {
  background-color: #ecf5ff;
  color: #337ecc;
}

.operation-btn:active {
  color: #3a8ee6;
}
</style>
